import { Loader } from "@zfp-akademie-a-s/zfp-design";
import { AdminRouting, getAdminUrl } from "Infrastructure/Utils/UrlUtils";
import { useEffect } from "react";

export const AdminClientContractsRedirect = () => {
  useEffect(() => {
    window.location.replace(getAdminUrl(AdminRouting.ClientContracts.path()));
  }, []);

  return <Loader />;
};
